export default __webpack_public_path__ + "static/media/lupeo.f8c4a59a.svg";